import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllSMSTemplates(_obj, params) {
    const res = await axios.get('api/sms/templates/', { params });
    return res.data;
  },
  async getSMSTemplate(_obj, id) {
    const res = await axios.get(`api/sms/templates/${id}/`);
    return res.data;
  },
  async createSMSTemplate(_obj, data) {
    return axios.post('api/sms/templates/', data);
  },
  async updateSMSTemplate(_obj, { id, data }) {
    return axios.patch(`api/sms/templates/${id}/`, data);
  },
  async deleteSMSTemplate(_obj, id) {
    return axios.delete(`api/sms/templates/${id}/`);
  },
};

export const smsTemplate = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
